import { formStoreLenses } from 'root/src/client/logic/form/lenses'

const { viewSubmitsBlock } = formStoreLenses

export default (state, { moduleId }) => viewSubmitsBlock(moduleId, state)
